
export enum enumFileUploadType {
  ImageFiles = "imageFiles",
  VideoFiles = "videoFiles",
  AudioFiles = "audioFiles",
  DocumentFiles = "documentFiles"
}